import React from "react";

import SkeletonBlock from "./SkeletonBlock";

/**
 * Small tag/badge skeleton — matches tag/badge styling.
 * h-[27px] rounded-[4px]
 *
 * @param {string|number} width — (default: 60)
 * @param {string}        className
 */
const SkeletonBadge = ({ width = 60, className }) => {
  return (
    <SkeletonBlock
      width={width}
      height="var(--skeleton-badge-height)"
      radius="sm"
      className={className}
    />
  );
};

export default SkeletonBadge;
